const HomepageActionTypes = {
  FETCH_RECENTLY_PLAYED_START: 'FETCH_RECENTLY_PLAYED_START',
  FETCH_RECENTLY_PLAYED_SUCCESS: 'FETCH_RECENTLY_PLAYED_SUCCESS',
  FETCH_RECENTLY_PLAYED_FAILURE: 'FETCH_RECENTLY_PLAYED_FAILURE',
  FETCH_TOP_ARTISTS_START: 'FETCH_TOP_ARTISTS_START',
  FETCH_TOP_ARTISTS_SUCCESS: 'FETCH_TOP_ARTISTS_SUCCESS',
  FETCH_TOP_ARTISTS_FAILURE: 'FETCH_TOP_ARTISTS_FAILURE',
  FETCH_TOP_TRACKS_START: 'FETCH_TOP_TRACKS_START',
  FETCH_TOP_TRACKS_SUCCESS: 'FETCH_TOP_TRACKS_SUCCESS',
  FETCH_TOP_TRACKS_FAILURE: 'FETCH_TOP_TRACKS_FAILURE',
  FETCH_RECOMMENDATIONS_START: 'FETCH_RECOMMENDATIONS_START',
  FETCH_RECOMMENDATIONS_SUCCESS: 'FETCH_RECOMMENDATIONS_SUCCESS',
  FETCH_RECOMMENDATIONS_FAILURE: 'FETCH_RECOMMENDATIONS_FAILURE',
  UPDATE_LIKED_RECOMMENDATIONS: 'UPDATE_LIKED_RECOMMENDATIONS'
};

export default HomepageActionTypes;
